<template>
  <div class="inkfilter">
	<ColorFilter/>
	<ManufFilter/>
        <div class="inkfilter_msg">
	Nota: as amostras tiveram as cores ajustadas para a melhor fidelidade possível, porém
        as tintas podem exibir cores impossíveis de escanear ou exibir, e seu
        monitor pode exibir cores ligeiramente diferentes.
	</div>
  </div>
</template>

<script>
import ColorFilter from './ColorFilter.vue';
import ManufFilter from './ManufFilter.vue';

export default {
	name: 'Inkfilter',
	components: { ColorFilter, ManufFilter }
}
</script>

<style scoped>
div.inkfilter {
	min-width: 15em;
	width: 15em;
	margin-right: 1em;
	padding-top: 3em;
	padding-bottom: 1em;
	position: -webkit-sticky; /* Safari */
	position: sticky;
	top: 0;
	height: 100vh;
}

div.inkfilter_msg {
}
</style>



// WEBPACK FOOTER //
// src/components/Inkfilter.vue